<!--
  Header height (finding F10): Figma's chrome on frame 128:4088 implies
  ~88px — the 48px logo sits at y=20 and the "Sign out" pill (32px) ends at
  y=60, which is exactly `flex items-center` centering both a 48px and a
  32px element inside an 88px band ((88-48)/2=20, (88-32)/2=28 — both match
  Figma's y-offsets precisely, so 88px isn't a rounded guess, it's the
  value both constraints imply together). Went with the full 88px rather
  than splitting the difference with the previous 64px: the header is
  shared chrome across every route including seat-selection, and 24px of
  extra chrome height (~2.7% of a 900px viewport) is a minor, one-time cost
  against getting the header's own geometry right, versus a partial value
  that would match neither the old nor the new spec exactly.
  `#main`'s `top-*` MUST stay equal to this height, or content renders
  underneath the header.
  Mobile (`h-12`, 48px) is left as-is — Figma's frame here is the 1280px
  desktop layout only; no mobile spec exists to size against (see the
  header component's own comments re: mobile).

  z-10 (plan B1): both this wrapper and `#main` below are `position: fixed`
  with no z-index of their own, so DOM order alone decided the stacking —
  `#main` painted over the header, clipping any overflow from the header's
  own gradient scrim (seat-selection). z-10 puts this wrapper above the map
  and, by making it a stacking context, keeps the scrim's own negative
  z-index local instead of letting it fall behind the map.
-->
<div class="z-10 fixed top-0 h-12 md:h-[88px] w-full">
  <app-header></app-header>
</div>

<!-- Loading screen -->
<!-- <app-loader></app-loader> -->

<!--
  `#main` top offset (seat-selection fix, plan Stream C item 4): everywhere else the page starts
  below the fixed header (`top-12`/`top-[88px]`), same as before. On seat-selection specifically
  it starts at `top-0` instead, so the DVM map genuinely renders behind the header's transparent
  gradient scrim (header.component.html's `showLegend` branch) rather than the header floating
  over an opaque plate standing in for the map. Seat-selection's own topbar/sidebar add their own
  top clearance to compensate (see viewer.component.html and sidebar.component.html) — this is
  the one route where the header is meant to overlap page content on purpose.
-->
<div
  id="main"
  class="w-full fixed bottom-0 overflow-auto"
  [ngClass]="isSeatSelectionRoute ? 'top-0' : 'top-12 md:top-[88px]'">
  <router-outlet></router-outlet>
</div>

<!-- Error -->
<!-- <app-error-modal></app-error-modal> -->
